import { isOneOf, textOf } from "../../search";
import type { ProviderAnswer } from "./ProviderCallbackPage";
import type { Provider } from "./providers";

const known: Record<Provider, true> = { google: true, apple: true, facebook: true };

/** What the callback's address carries. A value it cannot read counts as absent, so a forged address shows a refusal
 * rather than an error page. */
export function validateProviderAnswer(search: Record<string, unknown>): ProviderAnswer {
  const provider = search["provider"];
  return {
    provider: isOneOf(known, provider) ? provider : undefined,
    code: textOf(search["code"]),
    error: textOf(search["error"]),
    error_code: textOf(search["error_code"]),
    error_description: textOf(search["error_description"]),
  };
}
